import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';

import { ToggleChip } from './interactive-chips/ToggleChip';

export type Option = { readonly id: string; readonly isSelected?: boolean | undefined; readonly label: string };

type ChipGroupSelect = {
    readonly groupName: string;
    readonly onChange: (toggledKey: string) => void;
    readonly options: ReadonlyArray<Option>;
};

export const MultiChipSelect: FunctionComponent<ChipGroupSelect> = ({ groupName, onChange, options }) => (
    <Grid container={true} gap={1}>
        <Typography variant="body1">{groupName}</Typography>
        <Grid alignItems="flex-start" container={true} flexDirection="column" gap={1}>
            {options.map(({ id, isSelected, label }) => (
                <ToggleChip key={id} isActive={isSelected} label={label} onClick={() => onChange(id)} />
            ))}
        </Grid>
    </Grid>
);
